import { useDialog } from '@ucheba/ui/components/Dialog/bll'
import { useCallback, useEffect } from 'react'
import { scrollTo } from '@ucheba/utils/helpers/components'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { authSelectors } from '@ucheba/store/auth'
import { removeQueryParameters, stringifyUrl } from '@ucheba/utils/helpers/router'
import { authCookieToken, coreQuery } from '@ucheba/utils/constants/core'
import { getParsedCookies } from '@ucheba/utils/helpers/core'

interface IUseProgramsOfficialRepresentative {
  (): {
    isOpen: boolean
    onOpen: () => void
    onClose: () => void
    scrollToBlock: () => void
    handleOpenDialog: () => void
  }
}

export const useProgramsOfficialRepresentative: IUseProgramsOfficialRepresentative =
  () => {
    const dialog = useDialog('programsOfficialRepresentativeId')
    const isAuth = useSelector(authSelectors.isAuth)
    const router = useRouter()

    const scrollToBlock = useCallback(() => scrollTo('questions'), [])

    useEffect(() => {
      if (router.query.questionPopUp && isAuth) {
        dialog.openDialog()

        router.replace(
          stringifyUrl(removeQueryParameters(router.asPath), {
            update: {
              ...router.query,
            },
            exclude: ['questionPopUp'],
          }),
          undefined,
          { shallow: true }
        )
      }
    }, [])

    const handleOpenDialog = useCallback(() => {
      const parsedCookie = getParsedCookies()
      const tokenString = parsedCookie[authCookieToken]

      if (isAuth && !!tokenString) {
        dialog.openDialog()
      } else {
        router.push(
          stringifyUrl('/auth', {
            update: {
              [coreQuery.redirect]: stringifyUrl(removeQueryParameters(router.asPath), {
                update: {
                  questionPopUp: 1,
                },
              }),
            },
          })
        )
      }
    }, [isAuth, dialog, router])

    return {
      isOpen: dialog.isActive,
      onClose: dialog.closeDialog,
      onOpen: dialog.openDialog,
      scrollToBlock,
      handleOpenDialog,
    }
  }
